<!-- Loading Indicator -->
<ng-container *ngIf="loadingProjects || loadingClient || loadingDropboxAccount">
    <div class="logo-container">
        <img class="img" src="/assets/img/logo.png" />
    </div>
    <div class="loading-container" role="status" id="loading">
        <div class="lds-facebook">
            <div></div>
            <div></div>
            <div></div>
        </div>
    </div>
</ng-container>

<!-- Configurations Page -->
<ng-container *ngIf="!loadingProjects && !loadingClient && !loadingDropboxAccount && showConfigurations">
    <div class="project-row selected">
        <i class="fas fa-backward" (click)="hideConfigure()"></i> Configurations
    </div>
    <app-configure></app-configure>
</ng-container>

<!-- Project Selected -->
<div *ngIf="!loadingProjects && !loadingClient && !loadingDropboxAccount && selectedProject" [ngClass]="{'hidden': showConfigurations }">
    <div class="project-row selected">
        <i class="fas fa-backward" (click)="selectedProject = ''"></i> {{ selectedProject.name }} <i class="fas fa-wrench" (click)="showConfigure()"></i>
    </div>
    <app-project [selectedProject]="selectedProject"></app-project>
</div>

<!-- List Projects -->
<ng-container *ngIf="!loadingProjects && !loadingClient && !loadingDropboxAccount && !showConfigurations && !selectedProject">
    <div class="project-row selected">Select a Project:</div>
    <ng-container *ngFor="let project of projects">
        <div class="project-row" (click)="selectProcoreProject(project)">
            {{ project.name }}
        </div>
    </ng-container>
</ng-container>